module.exports = __webpack_public_path__ + "static/media/filter.2117a665.png";